export const TARGET_GEOGRAPHIES = [
  'North America',
  'Ireland & UK',
  'Europe',
  'Latin America',
  'APAC (Asia-Pacific)',
  'Middle East & Africa',
  'Global (No geographic limitation)',
] as const;

export const MAX_TARGET_GEOGRAPHIES = 4;

/** Drops unknown values, dedupes, returns canonical order. */
export function normalizeGeographies(values: unknown): string[] {
  if (!Array.isArray(values)) return [];
  const canonical = new Set(
    values
      .filter((v): v is string => typeof v === 'string')
      .map((v) => v.trim())
      .filter((v) => TARGET_GEOGRAPHIES.includes(v as (typeof TARGET_GEOGRAPHIES)[number])),
  );
  return TARGET_GEOGRAPHIES.filter((geo) => canonical.has(geo));
}
